/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { BasicSettingsContainer as BasicSettings } from './BasicSettings.container';
